
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsSquareGallery.components.SquareGallery',
  name: 'SquareGallery',
  mixins: [PaginatedReviewResourceView],
  props: {
    cols: {
      type: Number,
      required: true
    },
    gutter: {
      type: Number,
      required: true
    },
    rowGap: {
      type: Number,
      default: 32
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection'
    ]),
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
